<template>
  <detail-layout>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rulesAPIRequests"
          ref="ruleForm"
          class="flex flex-row w-full"
          autocomplete="off"
        >
          <div class="flex-1">
            <div class="lg:mb-4">
            </div>

            <div class="lg:mb-2" v-if="(role === 'AdminDistribuidor' || role === 'SuperAdminDistribuidor' || role === 'SuperAdministrador')">
              <div class="flex justify-between items-center">
                <div class="flex-1">
                  <AccessibleElSelect
                    v-model="form.clienteId"
                    prop="clienteId"
                    :options="clientesForAccessibleSelect"
                    :isDisabled="!isCreate"
                    id-prefix="apirequest"
                  >
                    <template slot="label">
                      <base-obligatory-icon v-if="isCreate"/>
                      {{$t('app.client')}}
                    </template>
                  </AccessibleElSelect>
                </div>
                <base-button
                  v-if="!isCreate"
                  class="ml-4"
                  mode="primary"
                  :text="$t('app.detail')"
                  @click.prevent.stop="goDetailClient"
                  :loading="isGeneralLoading"
                />
              </div>
            </div>

            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('peticionapi.NombreAccion')}}
                  <el-form-item prop="NombreAccion">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.NombreAccion"
                      maxlength='30'
                    />
                  </el-form-item>
                </label>
              </div>
            </div>

            <div class="mb-6">
              <AccessibleElSelect
                v-model="form.Metodo"
                prop="Metodo"
                :options="tiposMetodoForAccessibleSelect"
                clearable
                id-prefix="apirequest"
              >
                <template slot="label">
                  <base-obligatory-icon/>
                  {{$t('peticionapi.Metodo')}}
                </template>
              </AccessibleElSelect>
            </div>

            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">
                  <div class="flex justify-between items-end">
                    <div>
                      <base-obligatory-icon/>
                      {{$t('peticionapi.URL')}}
                    </div>
                    <base-button 
                      style="width: 160px"
                      mode="primary" 
                      size="xs"
                      :text="$t('clients.new_metadata')" 
                      @click.prevent.stop="toggleInsertTag" 
                      :loading="isGeneralLoading"/>
                  </div>
                  <el-form-item prop="URL" class="w-full">
                    <el-input
                      ref="formURL"
                      clearable
                      class="w-full"
                      v-model="form.URL"
                      maxlength='2000'
                      type="textarea"
                      :rows="3"
                    />
                  </el-form-item>
                </label>
              </div>
            </div>

            <div class="lg:mb-2 w-full">
              <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-2">Cabeceras</h2>
              <el-table
                ref="Cabeceras"
                :data="form.Cabeceras"
                style="width: 100%"
                :show-header="false">
                <el-table-column
                  prop="Campo"
                  label="Campo"
                  show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                  prop="Valor"
                  label="Valor"
                  show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                  prop="actions"
                  width="80"
                  align="center"
                  label="-">
                  <template slot-scope="scope">
                  <div class="flex flex-row">
                    <base-button-icon @click="deleteCabecera(scope.row)" name="trash" mode="core" size="xs" ariaLabel="Eliminar cabecera"/>
                  </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="w-full mt-4 mb-6 flex justify-end">
              <base-button-responsive
                mode="primary"
                :text="$t('peticionapi.new_header')"
                @click="newCabecera()"
                icon="plus"
              />
            </div>

            <div class="mb-6">
              <AccessibleElSelect
                v-model="form.ContentType"
                prop="ContentType"
                :options="tiposContentTypeForAccessibleSelect"
                :isDisabled="true"
                clearable
                id-prefix="apirequest"
              >
                <template slot="label">
                  <base-obligatory-icon/>
                  {{$t('peticionapi.ContentType')}}
                </template>
              </AccessibleElSelect>
            </div>

            <div class="lg:mb-2" v-show="methodWithBody">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">
                  <div class="flex justify-between items-end">
                    {{$t('peticionapi.Cuerpo')}}
                    <base-button 
                      style="width: 160px"
                      mode="primary" 
                      size="xs"
                      :text="$t('clients.new_metadata')" 
                      @click.prevent.stop="toggleInsertTagBody" 
                      :loading="isGeneralLoading"/>
                  </div>
                  <el-form-item prop="Cuerpo">
                    <el-input
                      id="formCuerpo"
                      ref="formCuerpo"
                      clearable
                      class="w-full"
                      v-model="form.Cuerpo"
                      maxlength='5000'
                      type="textarea"
                      :rows="7"
                    />
                  </el-form-item>
                </label>
              </div>
            </div>

            <div class="mb-6" v-if="hasModuleOrgProvinces">
              <label for="switch-organismo-provincia" class="sr-only">
                {{$t('peticionapi.OrganismoProvinciaRequerido')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}
              </label>
              <div class="flex flex-row items-center">
                <el-switch 
                  id="switch-organismo-provincia"
                  :aria-label="$t('peticionapi.OrganismoProvinciaRequerido')"
                  class="switch-text break-normal" 
                  v-model="form.OrganismoProvinciaRequerido" 
                  :active-text="$t('peticionapi.OrganismoProvinciaRequerido')">
                </el-switch>
              </div>
            </div>

            <div class="mb-6" v-if="!form.Automatico">
              <label for="switch-ejecucion-unica" class="sr-only">
                {{$t('peticionapi.EjecucionUnica')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}
              </label>
              <div class="flex flex-row items-center">
                <el-switch 
                  id="switch-ejecucion-unica"
                  :aria-label="$t('peticionapi.EjecucionUnica')"
                  class="switch-text break-normal" 
                  v-model="form.EjecucionUnica" 
                  :active-text="$t('peticionapi.EjecucionUnica')">
                </el-switch>
              </div>
            </div>

            <div class="mb-6">
              <label for="switch-activo" class="sr-only">
                {{$t('app.active')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}
              </label>
              <div class="flex flex-row items-center">
                <el-switch 
                  id="switch-activo"
                  :aria-label="$t('app.active')"
                  class="switch-text break-normal" 
                  v-model="form.Activo" 
                  :active-text="$t('app.active')">
                </el-switch>
              </div>
            </div>

            
          <base-collapsible-form 
            ref="baseCollapsibleAutenticacion" 
            class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-4">
            <template slot="headerRight">
              <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('peticionapi.header_autenticacion')}}</h2>
            </template>
            <template slot="content">

            <div class="mb-6">
              <AccessibleElSelect
                v-model="form.TipoAutenticacion"
                prop="TipoAutenticacion"
                :options="tiposTipoAutenticacionForAccessibleSelect"
                clearable
                id-prefix="apirequest"
              >
                <template slot="label">
                  <base-obligatory-icon/>
                  {{$t('peticionapi.TipoAutenticacion')}}
                </template>
              </AccessibleElSelect>
            </div>

            <div class="lg:mb-2" v-if="form.TipoAutenticacion === 3">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('peticionapi.URLAutenticacion')}}
                  <el-form-item prop="URLAutenticacion">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.URLAutenticacion"
                      maxlength='2000'
                      type="textarea"
                      :rows="3"
                    />
                  </el-form-item>
                </label>
              </div>
            </div>

            <div class="lg:mb-2" v-if="form.TipoAutenticacion === 2 || form.TipoAutenticacion === 3">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('peticionapi.UsuarioAutenticacion')}}
                  <el-form-item prop="UsuarioAutenticacion">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.UsuarioAutenticacion"
                      maxlength='100'
                    />
                  </el-form-item>
                </label>
              </div>
            </div>

            <div class="lg:mb-2" v-if="form.TipoAutenticacion === 2 || form.TipoAutenticacion === 3">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('peticionapi.PasswordAutenticacion')}}
                  <el-form-item prop="PasswordAutenticacion">
                    <el-input
                      ref="passwordInputApiRequest"
                      :disabled="disableEditPass"
                      clearable
                      show-password
                      class="w-full"
                      v-model="form.PasswordAutenticacion"
                      autocomplete="new-password"
                      maxlength='100'
                      >
                      <base-button-icon
                        v-if="visibleEditPass"
                        slot="append" 
                        @click="editSmtpPassToggle()"
                        :name="disableEditPass ? 'editpencil' : 'cross'"
                        :ariaLabel="disableEditPass ? 'Editar contraseña' : 'Cancelar edición de contraseña'"
                        iconSize="md"
                        size="xs"
                        mode="primary-phantom"
                        class="bg-primary-100 hover:bg-primary-200 dark:bg-darkblue-800 dark:text-darkblue-200 rounded-full"
                      />
                    </el-input>
                  </el-form-item>
                </label>
              </div>
            </div>

            <div class="lg:mb-2" v-show="form.TipoAutenticacion === 3">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">
                  <div class="flex justify-between items-end">
                    {{$t('peticionapi.CuerpoAutenticacion')}}
                    <base-button 
                      style="width: 160px"
                      mode="primary" 
                      size="xs"
                      :text="$t('clients.new_metadata')" 
                      @click.prevent.stop="toggleInsertTagBodyAuth" 
                      :loading="isGeneralLoading"/>
                  </div>
                  <el-form-item prop="CuerpoAutenticacion">
                    <el-input
                      id="formCuerpoAutenticacion"
                      ref="formCuerpoAutenticacion"
                      clearable
                      class="w-full"
                      v-model="form.CuerpoAutenticacion"
                      maxlength='5000'
                      type="textarea"
                      :rows="5"
                    />
                  </el-form-item>
                </label>
              </div>
            </div>

            <div class="lg:mb-2" v-if="form.TipoAutenticacion === 3">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('peticionapi.RutaTokenResponse')}}
                  <el-form-item prop="RutaTokenResponse">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.RutaTokenResponse"
                      maxlength='2000'
                      type="textarea"
                      :rows="3"
                    />
                  </el-form-item>
                </label>
              </div>
            </div>

            <div class="lg:mb-2 w-full" v-if="form.TipoAutenticacion === 3">
              <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-2">Cabeceras en petición de autenticación</h2>
              <el-table
                ref="CabecerasAutenticacion"
                :data="form.CabecerasAutenticacion"
                style="width: 100%"
                :show-header="false">
                <el-table-column
                  prop="Campo"
                  label="Campo"
                  show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                  prop="Valor"
                  label="Valor"
                  show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                  prop="actions"
                  width="80"
                  align="center"
                  label="-">
                  <template slot-scope="scope">
                  <div class="flex flex-row">
                    <base-button-icon @click="deleteCabeceraAutenticacion(scope.row)" name="trash" mode="core" size="xs" ariaLabel="Eliminar cabecera de autenticación"/>
                  </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="w-full mt-4 mb-6 flex justify-end" v-if="form.TipoAutenticacion === 3">
              <base-button-responsive
                mode="primary"
                :text="$t('peticionapi.new_header')"
                @click="newCabeceraAutenticacion()"
                icon="plus"
              />
            </div>

            </template>
          </base-collapsible-form>

          <base-collapsible-form 
            ref="baseCollapsibleAplication" 
            class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-6">
            <template slot="headerRight">
              <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('peticionapi.header_aplication')}}</h2>
            </template>
            <template slot="content">

            <div class="mb-6">
              <label for="switch-automatico" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                {{$t('peticionapi.Automatico')}}
                <span class="sr-only">{{$t('app.options')}}: {{$t('peticionapi.Automatico_Manual')}} / {{$t('peticionapi.Automatico_Auto')}}</span>
              </label>
              <el-switch 
                id="switch-automatico"
                :aria-label="$t('peticionapi.Automatico')"
                class="switch-text break-normal both-switch mt-2" 
                v-model="form.Automatico" 
                :active-text="$t('peticionapi.Automatico_Auto')"
                :inactive-text="$t('peticionapi.Automatico_Manual')"
                inactive-color="var(--primary-800)"/>
            </div>

            <div class="mb-6" v-if="!form.Automatico">
              <AccessibleElSelect
                v-model="form.idEstadosIniciales"
                prop="idEstadosIniciales"
                :options="tiposEstadosEntradaForAccessibleSelect"
                :isMultiple="true"
                clearable
                id-prefix="apirequest"
              >
                <template slot="label">
                  <base-obligatory-icon/>
                  {{$t('peticionapi.estados_origen')}}
                </template>
              </AccessibleElSelect>
            </div>

            <div class="mb-6">
              <AccessibleElSelect
                v-model="form.idEstadoDestino"
                prop="idEstadoDestino"
                :options="tiposEstadosSalidaForAccessibleSelect"
                clearable
                id-prefix="apirequest"
              >
                <template slot="label">{{$t('app.estado_destino')}}</template>
              </AccessibleElSelect>
            </div>

            </template>
          </base-collapsible-form>

          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive
            mode="secondary"
            :text="isCreate ? $t('app.cancel') : $t('app.back')"
            icon="cross"
            @click="goBack"
            :loading="isGeneralLoading"
          />
          <base-button-responsive
            mode="primary"
            :text="$t('app.save')"
            icon="save"
            @click="submitForm('ruleForm')"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>
      
        <input-two-text-dialog 
          :dialogOpen="showNewCabecera" 
          @toggleDialog="toggleDialogCabecera" 
          @applyDialog="applyDialogCabeceraHandler"
          header="Añadir nueva cabecera" 
          headerValue="Nombre" 
          header2Value="Valor" 
          :maxLength="250"
          :maxLength2="2000"
          />

        <input-two-text-dialog 
          :dialogOpen="showNewCabeceraAutenticacion" 
          @toggleDialog="toggleDialogCabeceraAutenticacion" 
          @applyDialog="applyDialogCabeceraAutenticacionHandler"
          header="Añadir nueva cabecera" 
          headerValue="Nombre" 
          header2Value="Valor" 
          :maxLength="250"
          :maxLength2="2000"
          />

        <BaseElDialog
          title="Inserción de metadato"
          :visible.sync="showModalTag"
            :close-on-click-modal="!isSelectDropdownOpen"
            @open="handleOpenModalDialog([
              'container-handleOpenModal-insert-metadata-body',
              'container-handleOpenModal-insert-metadata',
              ])"
            @closed="releaseFocusDialog"
          width="40%"
          custom-class="min-width-dialog"
          center
          :show-close="false">
          <div 
            class="overflow-x-hidden"
            ref="container-handleOpenModal-insert-metadata-body"
            >
            <el-form
              :model="formTag"
              ref="tagRules"
              :rules="tagRules"
            >
              <div class="lg:mb-2">
                <AccessibleElSelect
                  v-model="formTag.tag"
                  prop="tag"
                  :options="tagsForAccessibleSelect"
                  :group="true"
                  clearable
                  id-prefix="apirequest-tag"
                >
                  <template slot="label">
                    <base-obligatory-icon/>
                    {{$t('app.tag_metadato')}}
                  </template>
                </AccessibleElSelect>
              </div>
            </el-form>
          </div>
          <template slot="footer" >
            <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-insert-metadata">
              <base-button class="w-full" @click.stop.prevent="showModalTag = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
              <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click.stop.prevent="() => {insertTag('tagRules')}"/>
            </div>
          </template>
        </BaseElDialog>
        <BaseElDialog
          title="Inserción de metadato"
          :visible.sync="showModalBodyAuthTag"
            :close-on-click-modal="!isSelectDropdownOpen"
            @open="handleOpenModalDialog([
              'container-handleOpenModal-insert-metadata-auth-body',
              'container-handleOpenModal-insert-metadata-auth',
              ])"
            @closed="releaseFocusDialog"
          width="40%"
          custom-class="min-width-dialog"
          center
          :show-close="false">
          <div 
            class="overflow-x-hidden"
            ref="container-handleOpenModal-insert-metadata-auth-body"
            >
            <el-form
              :model="formTagAutenticacion"
              ref="tagRulesAutenticacion"
              :rules="tagRulesAutenticacion"
            >
              <div class="lg:mb-2">
                <AccessibleElSelect
                  v-model="formTagAutenticacion.tag"
                  prop="tag"
                  :options="tagsAutenticacionForAccessibleSelect"
                  clearable
                  id-prefix="apirequest-tag-auth"
                >
                  <template slot="label">
                    <base-obligatory-icon/>
                    {{$t('app.tag_metadato')}}
                  </template>
                </AccessibleElSelect>
              </div>
            </el-form>
          </div>
          <template slot="footer" >
            <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-insert-metadata-auth">
              <base-button class="w-full" @click.stop.prevent="showModalBodyAuthTag = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
              <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click.stop.prevent="() => {insertTagAutenticacion('tagRulesAutenticacion')}"/>
            </div>
          </template>
        </BaseElDialog>
    </template>
  </detail-layout>
</template>

<script>
import DetailLayout from '@/components/layout/DetailLayout.vue'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'
import { dropdownState } from '@/state/dropdownState'
import { i18n } from '@/i18n'
import BaseElDialog from '@/components/base/BaseElDialog.vue'

import { getClients } from '@/services/clients/getClients'

import { getApiRequest } from '@/services/configurations/rules/getApiRequest'
import { newApiRequest } from '@/services/configurations/rules/newApiRequest'
import { updateApiRequest } from '@/services/configurations/rules/updateApiRequest'
import { getMetadatosPeticionesAPICliente } from '@/services/clients/getMetadatosPeticionesAPICliente'

import { TIPOS_ESTADO_DESCARGA } from '@/config/tipos-estado-descarga'
import { TIPOS_AUTENTICACION_API } from '@/config/tipos-autenticacion-api'
import { TAGS_AUTENTICACION_API } from '@/config/tags-autenticacion-api'  
import { TIPOS_METHODS } from '@/config/tipos-methods' 

import InputTwoTextDialog from '@/components/InputTwoTextDialog.vue'

export default {
  /* eslint-disable camelcase */
  name: 'api-request-detail',
  components: {
    DetailLayout,
    AccessibleElSelect,
    BaseElDialog,
    InputTwoTextDialog,
  },
  data: function () {
    return {
      isMounted: false,
      searchView: false,
      activeName: 'es',
      localUserId: null,
      showModalTag: false,
      inputBodyActive: false,
      showModalBodyAuthTag: false,
      lastIndexCharacterStart: 0,
      lastIndexCharacterStartBody: 0,
      lastIndexCharacterStartBodyAutenticacion: 0,
      header: {
        title: 'DETALLE DE PETICIÓN A API',
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'configurations/apirequests'
      },

      visibleEditPass: true,
      disableEditPass: true,

      showNewCabecera: false,
      showNewCabeceraAutenticacion: false,
      numMaxCabeceras: 20,
      loadingFirstTime: false,
      tiposEstadoDescarga: TIPOS_ESTADO_DESCARGA,
      firstLoad: true,
      form: this.getDefaultForm(),
      formTag: {
        tag: null,
      },
      formTagAutenticacion: {
        tag: null,
      },
      tagsLoading: false,
      tags: [],
      tagsAutenticacion: TAGS_AUTENTICACION_API,
      clientes: [],
      tiposTipoAutenticacion: TIPOS_AUTENTICACION_API,
      tiposContentType: ['application/json'],
      tiposMetodo: TIPOS_METHODS,
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      tagRules: {
        tag: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
      },
      tagRulesAutenticacion: {
        tag: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
      },
      rulesAPIRequests: {
        clienteId: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        NombreAccion: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        URL: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        URLAutenticacion: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        RutaTokenResponse: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        ContentType: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        Metodo: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        TipoAutenticacion: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        UsuarioAutenticacion: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        PasswordAutenticacion: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        idEstadosIniciales: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
      },
    }
  },
  computed: {
    empresaFilter () {
      return this.isCreate ? this.$store.getters['apirequests/getMasterFilters']?.empresa?.value || null : null
    },
    isSelectDropdownOpen () {
      return dropdownState.isAnyDropdownOpen
    },
    hasModuleOrgProvinces () {
      return this.$store.getters['auth/hasModuleOrgProvinces']
    },
    methodWithBody () {
      if (!this.form.Metodo) return false
      return this.tiposMetodo.filter(x => x.value === this.form.Metodo)[0].body
    },
    estadosOrigenSelected () {
      if (!this.form.idEstadosIniciales || this.form.idEstadosIniciales.length === 0) return []
      return this.tiposEstadoDescarga.filter(x => this.form.idEstadosIniciales.includes(x.id))
    },
    estadoOrigenSinDestino () {
      if (this.estadosOrigenSelected.length === 0) return false
      return this.estadosOrigenSelected.some(x => x.FlujoSinDestino)
    },
    tiposEstadosEntrada () {
      return this.tiposEstadoDescarga
    },
    tiposEstadosSalida () { 
      if (this.form.Automatico) {
        return this.tiposEstadoDescarga
          .filter(x => x.TipoEstadoFlujo === 'Descarga')
          .filter(x => !x.FlujoSalidaoDeshabilitado)
      }

      if (this.estadosOrigenSelected.length === 0 || this.estadoOrigenSinDestino) return [] 
      if (this.estadosOrigenSelected.length !== this.estadosOrigenSelected.filter(x => x.TipoEstadoFlujo === this.estadosOrigenSelected[0].TipoEstadoFlujo).length) return [] 

      let res = this.tiposEstadoDescarga
      res = res
        // .filter(x => x.id !== this.estadosOrigenSelected.id)
        .filter(x => !this.estadosOrigenSelected.some(y => y.id === x.id))
        .filter(x => !x.FlujoSalidaoDeshabilitado)
        .filter(x => x.TipoEstadoFlujo === this.estadosOrigenSelected[0].TipoEstadoFlujo)

      return res
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    id: function () {
      return parseInt(this.$route.params.id)
    },
    isCreate: function () {
      return this.id === -1 || this.id === '-1'
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    clientesForAccessibleSelect () {
      return this.clientes.map(cliente => ({ 
        id: cliente.IdEmpresa, 
        value: cliente.IdEmpresa, 
        name: cliente.Nombre 
      }))
    },
    tiposMetodoForAccessibleSelect () {
      return this.tiposMetodo.map(metodo => ({ 
        id: metodo.value, 
        value: metodo.value, 
        name: metodo.value 
      }))
    },
    tiposContentTypeForAccessibleSelect () {
      return this.tiposContentType.map(tipo => ({ 
        id: tipo, 
        value: tipo, 
        name: tipo 
      }))
    },
    tiposTipoAutenticacionForAccessibleSelect () {
      return this.tiposTipoAutenticacion.map(tipo => ({ 
        id: tipo.id, 
        value: tipo.id, 
        name: tipo.name 
      }))
    },
    tiposEstadosEntradaForAccessibleSelect () {
      return this.tiposEstadosEntrada.map(estado => ({ 
        id: estado.id, 
        value: estado.id, 
        name: estado.Nombre 
      }))
    },
    tiposEstadosSalidaForAccessibleSelect () {
      return this.tiposEstadosSalida.map(estado => ({ 
        id: estado.id, 
        value: estado.id, 
        name: estado.Nombre 
      }))
    },
    tagsForAccessibleSelect () {
      return this.tags.map(group => ({
        label: group.Tipo,
        options: group.Metadatos ? group.Metadatos.map(item => ({
          id: item.Tag,
          value: item.Tag,
          name: item.Descripcion
        })) : []
      }))
    },
    tagsAutenticacionForAccessibleSelect () {
      return this.tagsAutenticacion.map(tag => ({ 
        id: tag.id, 
        value: tag.id, 
        name: tag.name 
      }))
    },
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    showModalTag (newValue, oldValue) {
      if (!newValue) {
        this.formTag.tag = ''
      } else {
        this.handleGetTagsMetadatosCliente()
      }
    },
    showModalBodyAuthTag (newValue, oldValue) {
      if (!newValue) this.formTagAutenticacion.tag = ''
    },
    'form.idEstadosIniciales': function (value, oldValue) {
      if (!this.loadingFirstTime) { 
        this.form.idEstadoDestino = null 
      }
    },
    'form.TipoAutenticacion': function (value, oldValue) {
      if (this.form.TipoAutenticacion === 2 || this.form.TipoAutenticacion === 3) {
        this.fixAccesibilityElInputPassword()
      }
    }
  },
  created: async function () {
    const breadcrumbs = []

    if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(dataClients.msgError + ' [Código de error: ' + dataClients.codError + ']')
      }
      this.clientes = dataClients.Empresas
      breadcrumbs.push({
        path: this.role === 'SuperAdministrador' ? 'configurationssa' : 'configurations',
        name: this.$i18n.t('app.configurations')
      })
      if (this.isCreate) this.preSelectClient(this.form, 'clienteId')
    } else {
      breadcrumbs.push({
        path: 'configurations',
        name: this.$i18n.t('app.configurations')
      })
    }
    breadcrumbs.push({ path: 'configurations/apirequests', name: this.$i18n.t('app.apirequests') })

    if (!this.isCreate) {
      this.loadingFirstTime = true
      await this.downloadData(this.id)
      breadcrumbs.push({ path: '', name: this.form.NombreAccion })
      this.$store.commit('app/setheaderBreadCrumb', this.form.NombreAccion)
    } else {
      this.visibleEditPass = false
      this.disableEditPass = false
      breadcrumbs.push({
        path: '',
        name: this.$i18n.t('peticionapi.new')
      })
    }
    this.header.breadcrumb = breadcrumbs
    this.$store.commit('setIsLoading', false)
  },
  mounted () {
    this.resetControlFormChanges()
    this.addRemoveEvents(false)

    this.fixAccesibilityElInputPassword()
  },
  beforeDestroy () {
    this.addRemoveEvents(true)
  },
  methods: {
    handleOpenModalDialog (refName) {
      this.handleOpenModalDialogMixin(refName)
    },
    releaseFocusDialog () {
      this.releaseFocusDialogMixin()
    },
    fixAccesibilityElInputPassword () {
      this.$nextTick(() => {
      // Timeout para esperar a que se rendericen los iconos
        setTimeout(() => {
          this.fixAccesibilityElInputPassword(this.$refs.passwordInputApiRequest, this.$i18n.t('aria.elementui.input.password'))
        }, 1000)
      })
    },
    editSmtpPassToggle () {
      if (this.disableEditPass) this.form.PasswordAutenticacion = ''
      else this.form.PasswordAutenticacion = '**********'
      this.disableEditPass = !this.disableEditPass
    },
    toggleShowHidePass (disable = true) {
      this.form.PasswordAutenticacion = disable ? '**********' : ''
      this.disableEditPass = disable
      this.visibleEditPass = disable
    },
    addRemoveEvents (remove = false) {
      const textareaURL = this.$refs.formURL.$el.querySelector('textarea')
      const textareaCuerpo = this.$refs.formCuerpo.$el.querySelector('#formCuerpo')
      const textareaCuerpoAutenticacion = this.$refs.formCuerpoAutenticacion.$el.querySelector('#formCuerpoAutenticacion')
      if (textareaURL) {
        if (remove) {
          textareaURL.removeEventListener('click', this.upateStartFormInput)
          textareaURL.removeEventListener('keyup', this.upateStartFormInput)
          textareaURL.removeEventListener('select', this.upateStartFormInput)
          textareaCuerpo.removeEventListener('click', this.upateStartFormInputCuerpo)
          textareaCuerpo.removeEventListener('keyup', this.upateStartFormInputCuerpo)
          textareaCuerpo.removeEventListener('select', this.upateStartFormInputCuerpo)
          textareaCuerpoAutenticacion.removeEventListener('click', this.updateStartFormInputCuerpoAutenticacion)
          textareaCuerpoAutenticacion.removeEventListener('keyup', this.updateStartFormInputCuerpoAutenticacion)
          textareaCuerpoAutenticacion.removeEventListener('select', this.updateStartFormInputCuerpoAutenticacion)
        } else {
          textareaURL.addEventListener('click', this.upateStartFormInput)
          textareaURL.addEventListener('keyup', this.upateStartFormInput)
          textareaURL.addEventListener('select', this.upateStartFormInput)
          textareaCuerpo.addEventListener('click', this.upateStartFormInputCuerpo)
          textareaCuerpo.addEventListener('keyup', this.upateStartFormInputCuerpo)
          textareaCuerpo.addEventListener('select', this.upateStartFormInputCuerpo)
          textareaCuerpoAutenticacion.addEventListener('click', this.updateStartFormInputCuerpoAutenticacion)
          textareaCuerpoAutenticacion.addEventListener('keyup', this.updateStartFormInputCuerpoAutenticacion)
          textareaCuerpoAutenticacion.addEventListener('select', this.updateStartFormInputCuerpoAutenticacion)
        }
      }
    },
    toggleInsertTag () {
      this.inputBodyActive = false
      this.showModalTag = !this.showModalTag
    },
    toggleInsertTagBody () {
      this.inputBodyActive = true
      this.showModalTag = !this.showModalTag
    },
    toggleInsertTagBodyAuth () {
      this.showModalBodyAuthTag = !this.showModalBodyAuthTag
    },
    handleGetTagsMetadatosCliente: async function () {
      if (this.form.clienteId) {
        this.tagsLoading = true
        this.tags = []
        const dataMetadatosAPI = await getMetadatosPeticionesAPICliente({ idCliente: this.form.clienteId })
        if (dataMetadatosAPI.blnError === false) {
          this.tags = dataMetadatosAPI.Respuesta
        } else {
          this.doFeedback(dataMetadatosAPI.msgError + ' [Código de error: ' + dataMetadatosAPI.codError + ']')
        }
        this.tagsLoading = false
      }
    },
    upateStartFormInput () {
      this.lastIndexCharacterStart = this.$refs.formURL.$el.querySelector('textarea')?.selectionStart
    },
    upateStartFormInputCuerpo () {
      this.lastIndexCharacterStartBody = this.$refs.formCuerpo.$el.querySelector('#formCuerpo')?.selectionStart
    },
    updateStartFormInputCuerpoAutenticacion () {
      this.lastIndexCharacterStartBodyAutenticacion = this.$refs.formCuerpoAutenticacion.$el.querySelector('#formCuerpoAutenticacion')?.selectionStart
    },
    insertTag: async function (ruleForm) {
      try {
        this.$refs[ruleForm].validate(async valid => {
          if (valid) {
            let newValue = ''
            if (this.inputBodyActive) {
              if (this.form.Cuerpo) newValue = this.form.Cuerpo
              const before = newValue.substring(0, this.lastIndexCharacterStartBody)
              const after = newValue.substring(this.lastIndexCharacterStartBody)
              newValue = before + this.formTag.tag + after
              this.form.Cuerpo = newValue
            } else {
              if (this.form.URL) newValue = this.form.URL
              const before = newValue.substring(0, this.lastIndexCharacterStart)
              const after = newValue.substring(this.lastIndexCharacterStart)
              newValue = before + this.formTag.tag + after
              this.form.URL = newValue
            }
            this.showModalTag = false
          } else {
            this.doFeedback('Error al procesar los datos, revise la información')
          }
        })
      } catch (error) {
        console.log(error)
        this.doFeedback()
      }
    },
    insertTagAutenticacion: async function (ruleForm) {
      try {
        this.$refs[ruleForm].validate(async valid => {
          if (valid) {
            let newValue = ''
            if (this.form.CuerpoAutenticacion) newValue = this.form.CuerpoAutenticacion
            const before = newValue.substring(0, this.lastIndexCharacterStartBodyAutenticacion)
            const after = newValue.substring(this.lastIndexCharacterStartBodyAutenticacion)
            newValue = before + this.formTagAutenticacion.tag + after
            this.form.CuerpoAutenticacion = newValue
            this.showModalBodyAuthTag = false
          } else {
            this.doFeedback('Error al procesar los datos, revise la información')
          }
        })
      } catch (error) {
        console.log(error)
        this.doFeedback()
      }
    },
    watchFormHandler () {
      this.$store.commit('app/setFormChanges', true)
    },
    getDefaultForm: function () {
      return {
        id: 0,
        clienteId: null,
        NombreAccion: '',
        URL: '',
        URLAutenticacion: '',
        CuerpoAutenticacion: '',
        RutaTokenResponse: '',
        CabecerasAutenticacion: [],
        ContentType: 'application/json',
        Automatico: false,
        Metodo: null,
        TipoAutenticacion: null,
        UsuarioAutenticacion: '',
        PasswordAutenticacion: '',
        Cuerpo: '',
        OrganismoProvinciaRequerido: false,
        Activo: false,
        EjecucionUnica: false,
        idEstadosIniciales: [],
        idEstadoDestino: null,
        Cabeceras: [],
      }
    },
    newCabecera: async function () {
      this.toggleDialogCabecera()
    },
    newCabeceraAutenticacion: async function () {
      this.toggleDialogCabeceraAutenticacion()
    },
    toggleDialogCabecera: function () {
      this.showNewCabecera = !this.showNewCabecera
    },
    toggleDialogCabeceraAutenticacion: function () {
      this.showNewCabeceraAutenticacion = !this.showNewCabeceraAutenticacion
    },
    applyDialogCabeceraHandler (payload) {
      try {
        this.$store.commit('app/setLoading', true)
        if (this.form.Cabeceras.length >= this.numMaxCabeceras) {
          this.doFeedback(`Se ha superado el número máximo de cabeceras permitidas (${this.numMaxCabeceras})`)
        } else if (this.form.Cabeceras.filter(x => x.Campo === payload.value).length > 0) {
          this.doFeedback('Ya se ha añadido esa cabecera')
        } else {
          this.form.Cabeceras.push({
            Campo: payload.value,
            Valor: payload.value2,
          })
          this.toggleDialogCabecera()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    applyDialogCabeceraAutenticacionHandler (payload) {
      try {
        this.$store.commit('app/setLoading', true)
        if (this.form.CabecerasAutenticacion.length >= this.numMaxCabeceras) {
          this.doFeedback(`Se ha superado el número máximo de cabeceras permitidas (${this.numMaxCabeceras})`)
        } else if (this.form.CabecerasAutenticacion.filter(x => x.Campo === payload.value).length > 0) {
          this.doFeedback('Ya se ha añadido esa cabecera')
        } else {
          this.form.CabecerasAutenticacion.push({
            Campo: payload.value,
            Valor: payload.value2,
          })
          this.toggleDialogCabeceraAutenticacion()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    deleteCabecera: async function (row) {
      try {
        this.$store.commit('app/setLoading', true)
        this.form.Cabeceras = this.form.Cabeceras.filter(x => x.Campo !== row.Campo)
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    deleteCabeceraAutenticacion: async function (row) {
      try {
        this.$store.commit('app/setLoading', true)
        this.form.CabecerasAutenticacion = this.form.CabecerasAutenticacion.filter(x => x.Campo !== row.Campo)
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    goDetailClient () {
      const id = this.form.clienteId
      this.$router.push({ name: 'configurations/clients/details', params: { id } })
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    submitForm: function (formName) {
      if (this.isCreate) {
        this.newApiRequestHandler(formName)
      } else {
        this.updateApiRequestHandler(formName)
      }
    },
    newApiRequestHandler: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const params = {
            idCliente: this.form.clienteId,
            NombreAccion: this.form.NombreAccion,
            URL: this.form.URL,
            URLAutenticacion: this.form.URLAutenticacion,
            CuerpoAutenticacion: this.form.CuerpoAutenticacion,
            RutaTokenResponse: this.form.RutaTokenResponse,
            CabecerasAutenticacion: this.form.CabecerasAutenticacion,
            ContentType: this.form.ContentType,
            Automatico: this.form.Automatico,
            Metodo: this.form.Metodo,
            idTipoAutenticacion: this.form.TipoAutenticacion,
            UsuarioAutenticacion: this.form.UsuarioAutenticacion,
            PasswordAutenticacion: this.form.PasswordAutenticacion,
            Cuerpo: this.form.Cuerpo,
            Activo: this.form.Activo,
            EjecucionUnica: this.form.EjecucionUnica,
            OrganismoProvinciaRequerido: this.form.OrganismoProvinciaRequerido,
            idEstadosIniciales: this.form.idEstadosIniciales,
            idEstadoDestino: this.form.idEstadoDestino,
            Cabeceras: this.form.Cabeceras,
          }
          const response = await newApiRequest(params)
          if (response.blnError === true) {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          } else {
            this.doFeedback('Datos guardados correctamente', 'success')
            this.resetForm()
            this.form = this.getDefaultForm()
            this.visibleEditPass = false
            this.disableEditPass = false
            this.resetControlFormChanges()
            if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
              this.preSelectClient(this.form, 'clienteId')
            }
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    resetForm () {
      this.$refs.ruleForm.resetFields()
    },
    updateApiRequestHandler: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const params = {
            idPeticion: this.form.id,
            NombreAccion: this.form.NombreAccion,
            URL: this.form.URL,
            URLAutenticacion: this.form.URLAutenticacion,
            CuerpoAutenticacion: this.form.CuerpoAutenticacion,
            RutaTokenResponse: this.form.RutaTokenResponse,
            CabecerasAutenticacion: this.form.CabecerasAutenticacion,
            ContentType: this.form.ContentType,
            Automatico: this.form.Automatico,
            Metodo: this.form.Metodo,
            idTipoAutenticacion: this.form.TipoAutenticacion,
            UsuarioAutenticacion: this.form.UsuarioAutenticacion,
            PasswordAutenticacion: this.disableEditPass ? null : this.form.PasswordAutenticacion,
            Cuerpo: this.form.Cuerpo,
            Activo: this.form.Activo,
            EjecucionUnica: this.form.EjecucionUnica,
            OrganismoProvinciaRequerido: this.form.OrganismoProvinciaRequerido,
            idEstadosIniciales: this.form.idEstadosIniciales,
            idEstadoDestino: this.form.idEstadoDestino,
            Cabeceras: this.form.Cabeceras,
          }
          const response = await updateApiRequest(params)
          if (response.blnError === false) {
            this.doFeedback('Datos guardados correctamente', 'success')
            this.updateView()
            this.toggleShowHidePass((this.form.TipoAutenticacion === 2 || this.form.TipoAutenticacion === 3))
            this.$store.commit('setAjaxRequestPending', false)
            this.resetControlFormChanges()
          } else {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    goBack: function () {
      this.$router.push({ name: 'configurations/apirequests' })
    },
    downloadData: async function (id) {
      let data = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idPeticion: id
        }
        data = await getApiRequest(params)
        this.setApiRequest(data.respuesta)
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return data
    },
    setApiRequest: function (data) {
      this.form.id = data.idPeticion
      this.form.clienteId = data.idCliente
      this.form.NombreAccion = data.NombreAccion
      this.form.URL = data.URL
      this.form.URLAutenticacion = data.URLAutenticacion
      this.form.CuerpoAutenticacion = data.CuerpoAutenticacion
      this.form.RutaTokenResponse = data.RutaTokenResponse
      this.form.CabecerasAutenticacion = data.CabecerasAutenticacion
      this.form.ContentType = data.ContentType
      this.form.Automatico = data.Automatico
      this.form.Metodo = data.Metodo
      this.form.TipoAutenticacion = data.idTipoAutenticacion
      this.form.UsuarioAutenticacion = data.UsuarioAutenticacion
      this.form.PasswordAutenticacion = data.PasswordAutenticacion
      this.toggleShowHidePass(data.idTipoAutenticacion === 2 || data.idTipoAutenticacion === 3)
      this.form.Cuerpo = data.Cuerpo
      this.form.Activo = data.Activo
      this.form.EjecucionUnica = data.EjecucionUnica
      this.form.OrganismoProvinciaRequerido = data.OrganismoProvinciaRequerido
      this.form.idEstadosIniciales = data.idEstadosIniciales
      this.form.idEstadoDestino = data.idEstadoDestino
      this.form.Cabeceras = data.Cabeceras ? data.Cabeceras : []
      setTimeout(() => {
        this.loadingFirstTime = false
      }, 100)
      this.resetControlFormChanges()
    },
    updateView: function () {
      this.header.breadcrumb[2].name = this.form.NombreAccion
      this.$store.commit('app/setheaderBreadCrumb', this.form.NombreAccion)
    },
  }
}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic > img {
  max-width: 100%;
  max-height: 100%;
}
</style>

<style lang="sass" scoped>
</style>
